import { Link } from "@tanstack/react-router";

import { Card, CardContent } from "@/components/Card/card";
import { FillScreen, VStack } from "@/components/Layout";
import { defaultNS, useTranslation } from "@/lib/i18n";

export function NotFound() {
  const { t } = useTranslation(defaultNS, { keyPrefix: "component.NotFound" });
  return (
    <FillScreen className="flex items-center justify-center">
      <Card className="max-w-dialog-sm">
        <CardContent className="px-14 py-14">
          <VStack className="items-center gap-4">
            <div className="text-3xl font-bold text-neutral-on-fill">
              {t("title")}
            </div>
            <p className="text-center text-neutral-muted-on-fill">
              {t("description")}
            </p>
            <Link to="/">{t("backToHome")}</Link>
          </VStack>
        </CardContent>
      </Card>
    </FillScreen>
  );
}
